__turbopack_context__.v({
  "menuMobile": "MenuMobile-module-scss-module__XyadXq__menuMobile",
  "menuMobileBox": "MenuMobile-module-scss-module__XyadXq__menuMobileBox",
  "menuMobileBtn": "MenuMobile-module-scss-module__XyadXq__menuMobileBtn",
  "menuMobileBurgerMenu": "MenuMobile-module-scss-module__XyadXq__menuMobileBurgerMenu",
  "menuMobileContainer": "MenuMobile-module-scss-module__XyadXq__menuMobileContainer",
  "menuMobileLogo": "MenuMobile-module-scss-module__XyadXq__menuMobileLogo",
  "menuMobileNavItem": "MenuMobile-module-scss-module__XyadXq__menuMobileNavItem",
  "menuMobileNavMenu": "MenuMobile-module-scss-module__XyadXq__menuMobileNavMenu",
  "menuMobileSvg": "MenuMobile-module-scss-module__XyadXq__menuMobileSvg",
  "menuMobile__link": "MenuMobile-module-scss-module__XyadXq__menuMobile__link",
  "menuMobile__links": "MenuMobile-module-scss-module__XyadXq__menuMobile__links",
  "svgClass": "MenuMobile-module-scss-module__XyadXq__svgClass",
  "svgClassHr_1": "MenuMobile-module-scss-module__XyadXq__svgClassHr_1",
  "svgClassHr_2": "MenuMobile-module-scss-module__XyadXq__svgClassHr_2",
  "svgClassHr_3": "MenuMobile-module-scss-module__XyadXq__svgClassHr_3",
});
